import { render, staticRenderFns } from "./ManagerInvitationModalWIthButton.vue?vue&type=template&id=2334ccc8"
import script from "./ManagerInvitationModalWIthButton.vue?vue&type=script&lang=ts"
export * from "./ManagerInvitationModalWIthButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2334ccc8')) {
      api.createRecord('2334ccc8', component.options)
    } else {
      api.reload('2334ccc8', component.options)
    }
    module.hot.accept("./ManagerInvitationModalWIthButton.vue?vue&type=template&id=2334ccc8", function () {
      api.rerender('2334ccc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/ManagerInvitationModalWIthButton.vue"
export default component.exports